const typographyCompleteActionModal = {
  post: 'Escribe tu comentario:',
  file: 'Adjuntar Archivos'
};

export default typographyCompleteActionModal;
